import React from 'react';
import DatePicker from 'react-datepicker';
import { Calendar } from 'lucide-react';

export default function DateTimePicker({
  value,
  onChange,
  placeholder = 'mm / dd / yyyy  --:--  --',
  minDate,
  disabled = false,
}) {
  // Filter out past times when today is selected
  const filterPassedTime = (time) => {
    const now = new Date();
    const selectedDate = value || now;

    // Only filter times if today is selected
    if (selectedDate.toDateString() !== now.toDateString()) return true;

    return time.getTime() > now.getTime();
  };

  return (
    <div className="relative flex items-center">
      <DatePicker
        selected={value}
        onChange={onChange}
        showTimeSelect
        timeIntervals={1}
        dateFormat="MM/dd/yyyy, h:mm aa"
        placeholderText={placeholder}
        minDate={minDate}
        filterTime={filterPassedTime}
        disabled={disabled}
        className="h-10 w-full rounded-md border border-slate-200 bg-background pl-3 pr-3 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
        wrapperClassName="flex-1"
      />
      <Calendar className="absolute right-3 h-4 w-4 text-muted-foreground pointer-events-none" />
    </div>
  );
}
